module.exports = __webpack_public_path__ + "josefin-ext.aa05eeb02d290ec3d594.woff2";


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/fonts/josefin-ext.woff2
// module id = ../../../../../angular/fonts/josefin-ext.woff2
// module chunks = 2